//
//
//
//
//
//
//
//
//
//
//
//
//

// noinspection JSUnusedGlobalSymbols
import { UserIcon } from 'vue-feather-icons'

export default {
  name: 'ApplicationsCounter',
  components: {
    UserIcon
  },
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
